export default {
  user: '/user',
  userAdminUpdate: '/update',
  getIndexationColumns: '/getIndexationColumns',
  getSeparators: '/getSeparators',
  storeBankParametrization: '/storeBankParametrization',
  showBankParametrization: '/showBankParametrization',
  storeBankFormFromFile: '/storeBankFormFromFile',
  showDatosGeneralesAll: '/showDatosGeneralesAll',
  showDatosGenerales: '/showDatosGenerales',
  storeDatosGenerales: '/storeDatosGenerales',
  showAnualLiquidation: '/showAnualLiquidation',
  showAnualLiquidations: '/showAnualLiquidations',
  storeFormData: '/storeFormData',
  updateFormData: '/updateFormData',
  storeParametrization1050: '/storeParametrization1050',
  showParametrization1050: '/showParametrization1050',
  storeDeclaration1050: '/storeDeclaration1050',
  showDeclaration1050: '/showDeclaration1050',
  storeDeclaration1050FromFile: '/storeDeclaration1050FromFile',
  updateDatosGenerales: '/updateDatosGenerales',
  showcliente: '/showcliente',
  storeDatosFiscales: '/storeDatosFiscales',
  storeDatosFiscalesFromImportedFile: '/storeDatosFiscalesFromImportedFile',
  storeParametrizacion: '/storeParametrizacion',
  showParametrizacion: '/showParametrizacion',
  storeLiquidationCede: '/storeLiquidationCede',
  storeLiquidAlicuotaReductionCede: '/storeLiquidAlicuotaReductionCede',
  storeIvaImportationCede: '/storeIvaImportationCede',
  storeIvaExportationCede: '/storeIvaExportationCede',
  storeIraeIrpfCede: '/storeIraeIrpfCede',
  storeCreditApplicationsOrOffsetsCede: '/storeCreditApplicationsOrOffsetsCede',
  storeTotalLiquidationTaxesCede: '/storeTotalLiquidationTaxesCede',
  storeDataLiquidationTaxesCede: '/storeDataLiquidationTaxesCede',
  getLiquidationCede: '/getLiquidationCede',
  getLiquidationTaxesCede: '/getLiquidationTaxesCede',
  getAlicuotaReductionCede: '/getAlicuotaReductionCede',
  getCreditApplicationsOrOffsetsCede: '/getCreditApplicationsOrOffsetsCede',
  getIraeIrpfCede: '/getIraeIrpfCede',
  getIvaExportationCede: '/getIvaExportationCede',
  getIvaImportationCede: '/getIvaImportationCede',
  getTotalLiquidationTaxesCede: '/getTotalLiquidationTaxesCede',
  deleteLiquidationCede: '/deleteLiquidationCede',
  storeLiquidAlicuotaReductionNoCede: '/storeLiquidAlicuotaReductionNoCede',
  storeIvaImportationNoCede: '/storeIvaImportationNoCede',
  storeIvaExportationNoCede: '/storeIvaExportationNoCede',
  storeIraeIrpfNoCede: '/storeIraeIrpfNoCede',
  storeCreditApplicationsOrOffsetsNoCede:
    'storeCreditApplicationsOrOffsetsNoCede',
  storeTotalLiquidationTaxesNoCede: '/storeTotalLiquidationTaxesNoCede',
  getScalingRanges: '/getScalingRanges',
  getScalingPercentages: '/getScalingPercentages',
}
